import React, {useEffect} from 'react'
import {observer, inject} from 'mobx-react';

const AuthPage = inject('authStore')(observer(({authStore}) => {
        useEffect(() => {
            authStore.authAndRedirect('/booking/cabinet')
        })
        return (
            <div/>
        );
    }
));

export default AuthPage
